import React from 'react';
import styled from 'styled-components';
import { Dot } from '@styled-icons/bootstrap';

import { FormattedDecimal } from './numbers.component';

function addressStr(address) {
    return `${address.address_1st_line} ${address.address_2nd_line}`;
}

const Container = styled.div`
    font-size: 1rem;
`

const Value = styled.div`
    font-weight: bold;
`

const Line = styled.div`
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  gap: 0.5rem;

  @media(min-width: 1000px) {
      gap: 1rem;
  }
`

const ColorDot = styled(Dot)`
    color: ${(props) => (props.value)};
    margin-top: -12px;
    width: 3rem;
`

export const LabelAndValueContent = (props) => {
    let line = <Line>
         <div>{props.label}:</div>
         <Value>{props.value}</Value>
    </Line>
    return (<Container>{line}</Container>)
}

export const LabelAndColorDecimalValueContent = (props) => {
    let formattedValue = <FormattedDecimal value={props.value} color="true" currency={props.currency} />
    let suffix = props.suffix ? <span>{props.suffix}</span> : "";
    let line = <Line>
        <div>{props.label}:</div>
        <Value>{formattedValue}</Value>
        {suffix}
    </Line>
    return (<Container>{line}</Container>)
}

export const InvoiceShortLine = ({ invoice }) => {
    const invoiceTranslations = {
        "WPL": "Wpłata",
        "KKW": "Korekta wpłaty",
        "ZWR": "Zwrot wpłaty"
    };
    let color = "var(--mdb-primary)";
    if (invoice.to_pay) {
        color = invoice.to_pay === 0 ? "var(--mdb-success)" : "var(--mdb-danger)";
    }
    let title = invoiceTranslations[invoice.codename] || invoice.codename;
    if (title === "FV") {
        title = invoice.nr;
    }
    let invdate = invoice.date.split('T')[0]
    return <Container>
        <Line>
            <ColorDot value={color} />
            <Value>{title}</Value>
            <Value>
                <FormattedDecimal value={invoice.brutto} currency='PLN' />
            </Value>
            <Value>{invdate}</Value>
        </Line>
    </Container>
}

export const ClientCodeAndName = ({ client_details }) => {
    let clientName = `${client_details.name} ${client_details.surname}`;
    return <>
        <LabelAndValueContent label='Numer klienta' value={client_details.code} />
        <LabelAndValueContent label='Imię i nazwisko/nazwa firmy' value={clientName} />
    </>
}

export const ClientAddresses = ({ client_details }) => {
    let main_data = addressStr(client_details.main_data);
    let data_for_inv = addressStr(client_details.data_for_inv);
    return <>
        <LabelAndValueContent label="Adres zameldowania/siedziby" value={main_data} />
        <LabelAndValueContent label="Adres na fakturze" value={data_for_inv} />
    </>
}
